export const nafCodes: Record<string, string> = {
  "01": "Culture et production animale, chasse et services annexes",
  "0111Z":
    "Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses",
  "0112Z": "Culture du riz",
  "0113Z": "Culture de légumes, de melons, de racines et de tubercules",
  "0114Z": "Culture de la canne à sucre",
  "0115Z": "Culture du tabac",
  "0116Z": "Culture de plantes à fibres",
  "0119Z": "Autres cultures non permanentes",
  "0121Z": "Culture de la vigne",
  "0122Z": "Culture de fruits tropicaux et subtropicaux",
  "0123Z": "Culture d'agrumes",
  "0124Z": "Culture de fruits à pépins et à noyau",
  "0125Z":
    "Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque",
  "0126Z": "Culture de fruits oléagineux",
  "0127Z": "Culture de plantes à boissons",
  "0128Z":
    "Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques",
  "0129Z": "Autres cultures permanentes",
  "0130Z": "Reproduction de plantes",
  "0141Z": "Élevage de vaches laitières",
  "0142Z": "Élevage d'autres bovins et de buffles",
  "0143Z": "Élevage de chevaux et d'autres équidés",
  "0144Z": "Élevage de chameaux et d'autres camélidés",
  "0145Z": "Élevage d'ovins et de caprins",
  "0146Z": "Élevage de porcins",
  "0147Z": "Élevage de volailles",
  "0149Z": "Élevage d'autres animaux",
  "0150Z": "Culture et élevage associés",
  "0161Z": "Activités de soutien aux cultures",
  "0162Z": "Activités de soutien à la production animale",
  "0163Z": "Traitement primaire des récoltes",
  "0164Z": "Traitement des semences",
  "0170Z": "Chasse, piégeage et services annexes",
  "02": "Sylviculture et exploitation forestière",
  "0210Z": "Sylviculture et autres activités forestières",
  "0220Z": "Exploitation forestière",
  "0230Z":
    "Récolte de produits forestiers non ligneux poussant à l'état sauvage",
  "0240Z": "Services de soutien à l'exploitation forestière",
  "03": "Pêche et aquaculture",
  "0311Z": "Pêche en mer",
  "0312Z": "Pêche en eau douce",
  "0321Z": "Aquaculture en mer",
  "0322Z": "Aquaculture en eau douce",
  "05": "Extraction de houille et de lignite",
  "0510Z": "Extraction de houille",
  "0520Z": "Extraction de lignite",
  "06": "Extraction d'hydrocarbures",
  "0610Z": "Extraction de pétrole brut",
  "0620Z": "Extraction de gaz naturel",
  "07": "Extraction de minerais métalliques",
  "0710Z": "Extraction de minerais de fer",
  "0721Z": "Extraction de minerais d'uranium et de thorium",
  "0729Z": "Extraction d'autres minerais de métaux non ferreux",
  "08": "Autres industries extractives",
  "0811Z":
    "Extraction de pierres ornementales et de construction, de calcaire industriel, de gypse, de craie et d'ardoise",
  "0812Z":
    "Exploitation de gravières et sablières, extraction d’argiles et de kaolin",
  "0891Z": "Extraction des minéraux chimiques et d'engrais minéraux",
  "0892Z": "Extraction de tourbe",
  "0893Z": "Production de sel",
  "0899Z": "Autres activités extractives n.c.a.",
  "09": "Services de soutien aux industries extractives",
  "0910Z": "Activités de soutien à l'extraction d'hydrocarbures",
  "0990Z": "Activités de soutien aux autres industries extractives",
  "10": "Industries alimentaires",
  "101":
    "Transformation et conservation de la viande et préparation de produits à base de viande",
  "1011": "Transformation et conservation de la viande de boucherie",
  "1011Z": "Transformation et conservation de la viande de boucherie",
  "1012": "Transformation et conservation de la viande de volaille",
  "1012Z": "Transformation et conservation de la viande de volaille",
  "1013": "Préparation de produits à base de viande",
  "1013A": "Préparation industrielle de produits à base de viande",
  "1013B": "Charcuterie",
  "102":
    "Transformation et conservation de poisson, de crustacés et de mollusques",
  "1020":
    "Transformation et conservation de poisson, de crustacés et de mollusques",
  "1020Z":
    "Transformation et conservation de poisson, de crustacés et de mollusques",
  "103": "Transformation et conservation de fruits et légumes",
  "1031": "Transformation et conservation de pommes de terre",
  "1031Z": "Transformation et conservation de pommes de terre",
  "1032": "Préparation de jus de fruits et légumes",
  "1032Z": "Préparation de jus de fruits et légumes",
  "1039": "Autre transformation et conservation de fruits et légumes",
  "1039A": "Autre transformation et conservation de légumes",
  "1039B": "Transformation et conservation de fruits",
  "104": "Fabrication d’huiles et graisses végétales et animales",
  "1041": "Fabrication d'huiles et graisses",
  "1041A": "Fabrication d'huiles et graisses brutes",
  "1041B": "Fabrication d'huiles et graisses raffinées",
  "1042": "Fabrication de margarine et graisses comestibles similaires",
  "1042Z": "Fabrication de margarine et graisses comestibles similaires",
  "105": "Fabrication de produits laitiers",
  "1051": "Exploitation de laiteries et fabrication de fromage",
  "1051A": "Fabrication de lait liquide et de produits frais",
  "1051B": "Fabrication de beurre",
  "1051C": "Fabrication de fromage",
  "1051D": "Fabrication d'autres produits laitiers",
  "1052": "Fabrication de glaces et sorbets",
  "1052Z": "Fabrication de glaces et sorbets",
  "106": "Travail des grains ; fabrication de produits amylacés",
  "1061": "Travail des grains",
  "1061A": "Meunerie",
  "1061B": "Autres activités du travail des grains",
  "1062": "Fabrication de produits amylacés",
  "1062Z": "Fabrication de produits amylacés",
  "107":
    "Fabrication de produits de boulangerie-pâtisserie et de pâtes alimentaires",
  "1071": "Fabrication de pain et de pâtisserie fraîche",
  "1071A": "Fabrication industrielle de pain et de pâtisserie fraîche",
  "1071B": "Cuisson de produits de boulangerie",
  "1071C": "Boulangerie et boulangerie-pâtisserie",
  "1071D": "Pâtisserie",
  "1072": "Fabrication de biscuits, biscottes et pâtisseries de conservation",
  "1072Z": "Fabrication de biscuits, biscottes et pâtisseries de conservation",
  "1073": "Fabrication de pâtes alimentaires",
  "1073Z": "Fabrication de pâtes alimentaires",
  "108": "Fabrication d'autres produits alimentaires",
  "1081": "Fabrication de sucre",
  "1081Z": "Fabrication de sucre",
  "1082": "Fabrication de cacao, chocolat et de produits de confiserie",
  "1082Z": "Fabrication de cacao, chocolat et de produits de confiserie",
  "1083": "Transformation du thé et du café",
  "1083Z": "Transformation du thé et du café",
  "1084": "Fabrication de condiments et assaisonnements",
  "1084Z": "Fabrication de condiments et assaisonnements",
  "1085": "Fabrication de plats préparés",
  "1085Z": "Fabrication de plats préparés",
  "1086": "Fabrication d'aliments homogénéisés et diététiques",
  "1086Z": "Fabrication d'aliments homogénéisés et diététiques",
  "1089": "Fabrication d'autres produits alimentaires n.c.a.",
  "1089Z": "Fabrication d'autres produits alimentaires n.c.a.",
  "109": "Fabrication d'aliments pour animaux",
  "1091": "Fabrication d'aliments pour animaux de ferme",
  "1091Z": "Fabrication d'aliments pour animaux de ferme",
  "1092": "Fabrication d'aliments pour animaux de compagnie",
  "1092Z": "Fabrication d'aliments pour animaux de compagnie",
  "11": "Fabrication de boissons",
  "110": "Fabrication de boissons",
  "1101": "Production de boissons alcooliques distillées",
  "1101Z": "Production de boissons alcooliques distillées",
  "1102": "Production de vin (de raisin)",
  "1102A": "Fabrication de vins effervescents",
  "1102B": "Vinification",
  "1103": "Fabrication de cidre et de vins de fruits",
  "1103Z": "Fabrication de cidre et de vins de fruits",
  "1104": "Production d'autres boissons fermentées non distillées",
  "1104Z": "Production d'autres boissons fermentées non distillées",
  "1105": "Fabrication de bière",
  "1105Z": "Fabrication de bière",
  "1106": "Fabrication de malt",
  "1106Z": "Fabrication de malt",
  "1107":
    "Industrie des eaux minérales et autres eaux embouteillées et des boissons rafraîchissantes",
  "1107A": "Industrie des eaux de table",
  "1107B": "Production de boissons rafraîchissantes",
  "111":
    "Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses",
  "112": "Culture du riz",
  "113": "Culture de légumes, de melons, de racines et de tubercules",
  "114": "Culture de la canne à sucre",
  "115": "Culture du tabac",
  "116": "Culture de plantes à fibres",
  "119": "Autres cultures non permanentes",
  "12": "Cultures permanentes",
  "120": "Fabrication de produits à base de tabac",
  "1200": "Fabrication de produits à base de tabac",
  "1200Z": "Fabrication de produits à base de tabac",
  "121": "Culture de la vigne",
  "122": "Culture de fruits tropicaux et subtropicaux",
  "123": "Culture d'agrumes",
  "124": "Culture de fruits à pépins et à noyau",
  "125": "Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque",
  "126": "Culture de fruits oléagineux",
  "127": "Culture de plantes à boissons",
  "128":
    "Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques",
  "129": "Autres cultures permanentes",
  "13": "Fabrication de textiles",
  "130": "Reproduction de plantes",
  "131": "Préparation de fibres textiles et filature",
  "1310": "Préparation de fibres textiles et filature",
  "1310Z": "Préparation de fibres textiles et filature",
  "132": "Tissage",
  "1320": "Tissage",
  "1320Z": "Tissage",
  "133": "Ennoblissement textile",
  "1330": "Ennoblissement textile",
  "1330Z": "Ennoblissement textile",
  "139": "Fabrication d'autres textiles",
  "1391": "Fabrication d'étoffes à mailles",
  "1391Z": "Fabrication d'étoffes à mailles",
  "1392": "Fabrication d'articles textiles, sauf habillement",
  "1392Z": "Fabrication d'articles textiles, sauf habillement",
  "1393": "Fabrication de tapis et moquettes",
  "1393Z": "Fabrication de tapis et moquettes",
  "1394": "Fabrication de ficelles, cordes et filets",
  "1394Z": "Fabrication de ficelles, cordes et filets",
  "1395": "Fabrication de non-tissés, sauf habillement",
  "1395Z": "Fabrication de non-tissés, sauf habillement",
  "1396": "Fabrication d'autres textiles techniques et industriels",
  "1396Z": "Fabrication d'autres textiles techniques et industriels",
  "1399": "Fabrication d'autres textiles n.c.a.",
  "1399Z": "Fabrication d'autres textiles n.c.a.",
  "14": "Production animale",
  "141": "Fabrication de vêtements, autres qu'en fourrure",
  "1411": "Fabrication de vêtements en cuir",
  "1411Z": "Fabrication de vêtements en cuir",
  "1412": "Fabrication de vêtements de travail",
  "1412Z": "Fabrication de vêtements de travail",
  "1413": "Fabrication de vêtements de dessus",
  "1413Z": "Fabrication de vêtements de dessus",
  "1414": "Fabrication de vêtements de dessous",
  "1414Z": "Fabrication de vêtements de dessous",
  "1419": "Fabrication d'autres vêtements et accessoires",
  "1419Z": "Fabrication d'autres vêtements et accessoires",
  "142": "Élevage d'autres bovins et de buffles",
  "1420": "Fabrication d'articles en fourrure",
  "1420Z": "Fabrication d'articles en fourrure",
  "143": "Élevage de chevaux et d'autres équidés",
  "1431": "Fabrication d'articles chaussants à mailles",
  "1431Z": "Fabrication d'articles chaussants à mailles",
  "1439": "Fabrication d'autres articles à mailles",
  "1439Z": "Fabrication d'autres articles à mailles",
  "144": "Élevage de chameaux et d'autres camélidés",
  "145": "Élevage d'ovins et de caprins",
  "146": "Élevage de porcins",
  "147": "Élevage de volailles",
  "149": "Élevage d'autres animaux",
  "15": "Industrie du cuir et de la chaussure",
  "150": "Culture et élevage associés",
  "151":
    "Apprêt et tannage des cuirs ; préparation et teinture des fourrures ; fabrication d'articles de voyage, de maroquinerie et de sellerie",
  "1511": "Apprêt et tannage des cuirs ; préparation et teinture des fourrures",
  "1511Z":
    "Apprêt et tannage des cuirs ; préparation et teinture des fourrures",
  "1512": "Fabrication d'articles de voyage, de maroquinerie et de sellerie",
  "1512Z": "Fabrication d'articles de voyage, de maroquinerie et de sellerie",
  "152": "Fabrication de chaussures",
  "1520": "Fabrication de chaussures",
  "1520Z": "Fabrication de chaussures",
  "16": "Activités de soutien à l'agriculture et traitement primaire des récoltes",
  "161": "Activités de soutien aux cultures",
  "1610": "Sciage et rabotage du bois",
  "1610A": "Sciage et rabotage du bois, hors imprégnation",
  "1610B": "Imprégnation du bois",
  "162": "Fabrication d'articles en bois, liège, vannerie et sparterie",
  "1621": "Fabrication de placage et de panneaux de bois",
  "1621Z": "Fabrication de placage et de panneaux de bois",
  "1622": "Fabrication de parquets assemblés",
  "1622Z": "Fabrication de parquets assemblés",
  "1623": "Fabrication de charpentes et d'autres menuiseries",
  "1623Z": "Fabrication de charpentes et d'autres menuiseries",
  "1624": "Fabrication d'emballages en bois",
  "1624Z": "Fabrication d'emballages en bois",
  "1629":
    "Fabrication d'objets divers en bois ; fabrication d'objets en liège, vannerie et sparterie",
  "1629Z":
    "Fabrication d'objets divers en bois ; fabrication d'objets en liège, vannerie et sparterie",
  "163": "Traitement primaire des récoltes",
  "164": "Traitement des semences",
  "17": "Chasse, piégeage et services annexes",
  "170": "Chasse, piégeage et services annexes",
  "171": "Fabrication de pâte à papier, de papier et de carton",
  "1711": "Fabrication de pâte à papier",
  "1711Z": "Fabrication de pâte à papier",
  "1712": "Fabrication de papier et de carton",
  "1712Z": "Fabrication de papier et de carton",
  "172": "Fabrication d'articles en papier ou en carton",
  "1721":
    "Fabrication de papier et carton ondulés et d'emballages en papier ou en carton",
  "1721A": "Fabrication de carton ondulé",
  "1721B": "Fabrication de cartonnages",
  "1721C": "Fabrication d'emballages en papier",
  "1722": "Fabrication d'articles en papier à usage sanitaire ou domestique",
  "1722Z": "Fabrication d'articles en papier à usage sanitaire ou domestique",
  "1723": "Fabrication d'articles de papeterie",
  "1723Z": "Fabrication d'articles de papeterie",
  "1724": "Fabrication de papiers peints",
  "1724Z": "Fabrication de papiers peints",
  "1729": "Fabrication d'autres articles en papier ou en carton",
  "1729Z": "Fabrication d'autres articles en papier ou en carton",
  "18": "Imprimerie et reproduction d'enregistrements",
  "181": "Imprimerie et services annexes",
  "1811": "Imprimerie de journaux",
  "1811Z": "Imprimerie de journaux",
  "1812": "Autre imprimerie (labeur)",
  "1812Z": "Autre imprimerie (labeur)",
  "1813": "Activités de pré-presse",
  "1813Z": "Activités de pré-presse",
  "1814": "Reliure et activités connexes",
  "1814Z": "Reliure et activités connexes",
  "182": "Reproduction d'enregistrements",
  "1820": "Reproduction d'enregistrements",
  "1820Z": "Reproduction d'enregistrements",
  "19": "Cokéfaction et raffinage",
  "191": "Cokéfaction",
  "1910": "Cokéfaction",
  "1910Z": "Cokéfaction",
  "192": "Raffinage du pétrole",
  "1920": "Raffinage du pétrole",
  "1920Z": "Raffinage du pétrole",
  "20": "Industrie chimique",
  "201":
    "Fabrication de produits chimiques de base, de produits azotés et d'engrais, de matières plastiques de base et de caoutchouc synthétique",
  "2011": "Fabrication de gaz industriels",
  "2011Z": "Fabrication de gaz industriels",
  "2012": "Fabrication de colorants et de pigments",
  "2012Z": "Fabrication de colorants et de pigments",
  "2013": "Fabrication d'autres produits chimiques inorganiques de base",
  "2013A": "Enrichissement et  retraitement de matières nucléaires",
  "2013B":
    "Fabrication d'autres produits chimiques inorganiques de base n.c.a.",
  "2014": "Fabrication d'autres produits chimiques organiques de base",
  "2014Z": "Fabrication d'autres produits chimiques organiques de base",
  "2015": "Fabrication de produits azotés et d'engrais",
  "2015Z": "Fabrication de produits azotés et d'engrais",
  "2016": "Fabrication de matières plastiques de base",
  "2016Z": "Fabrication de matières plastiques de base",
  "2017": "Fabrication de caoutchouc synthétique",
  "2017Z": "Fabrication de caoutchouc synthétique",
  "202": "Fabrication de pesticides et d’autres produits agrochimiques",
  "2020": "Fabrication de pesticides et d’autres produits agrochimiques",
  "2020Z": "Fabrication de pesticides et d’autres produits agrochimiques",
  "203": "Fabrication de peintures, vernis, encres et mastics",
  "2030": "Fabrication de peintures, vernis, encres et mastics",
  "2030Z": "Fabrication de peintures, vernis, encres et mastics",
  "204": "Fabrication de savons, de produits d'entretien et de parfums",
  "2041": "Fabrication de savons, détergents et produits d'entretien",
  "2041Z": "Fabrication de savons, détergents et produits d'entretien",
  "2042": "Fabrication de parfums et de produits pour la toilette",
  "2042Z": "Fabrication de parfums et de produits pour la toilette",
  "205": "Fabrication d'autres produits chimiques",
  "2051": "Fabrication de produits explosifs",
  "2051Z": "Fabrication de produits explosifs",
  "2052": "Fabrication de colles",
  "2052Z": "Fabrication de colles",
  "2053": "Fabrication d'huiles essentielles",
  "2053Z": "Fabrication d'huiles essentielles",
  "2059": "Fabrication d'autres produits chimiques n.c.a.",
  "2059Z": "Fabrication d'autres produits chimiques n.c.a.",
  "206": "Fabrication de fibres artificielles ou synthétiques",
  "2060": "Fabrication de fibres artificielles ou synthétiques",
  "2060Z": "Fabrication de fibres artificielles ou synthétiques",
  "21": "Sylviculture et autres activités forestières",
  "210": "Sylviculture et autres activités forestières",
  "211": "Fabrication de produits pharmaceutiques de base",
  "2110": "Fabrication de produits pharmaceutiques de base",
  "2110Z": "Fabrication de produits pharmaceutiques de base",
  "212": "Fabrication de préparations pharmaceutiques",
  "2120": "Fabrication de préparations pharmaceutiques",
  "2120Z": "Fabrication de préparations pharmaceutiques",
  "22": "Fabrication de produits en caoutchouc et en plastique",
  "220": "Exploitation forestière",
  "221": "Fabrication de produits en caoutchouc",
  "2211": "Fabrication et rechapage de pneumatiques",
  "2211Z": "Fabrication et rechapage de pneumatiques",
  "2219": "Fabrication d'autres articles en caoutchouc",
  "2219Z": "Fabrication d'autres articles en caoutchouc",
  "222": "Fabrication  de produits en plastique",
  "2221":
    "Fabrication de plaques, feuilles, tubes et profilés en matières plastiques",
  "2221Z":
    "Fabrication de plaques, feuilles, tubes et profilés en matières plastiques",
  "2222": "Fabrication d'emballages en matières plastiques",
  "2222Z": "Fabrication d'emballages en matières plastiques",
  "2223": "Fabrication d'éléments en matières plastiques pour la construction",
  "2223Z": "Fabrication d'éléments en matières plastiques pour la construction",
  "2229": "Fabrication d'autres articles en matières plastiques",
  "2229A": "Fabrication de pièces techniques à base de matières plastiques",
  "2229B":
    "Fabrication de produits de consommation courante en matières plastiques",
  "23": "Fabrication d'autres produits minéraux non métalliques",
  "230": "Récolte de produits forestiers non ligneux poussant à l'état sauvage",
  "231": "Fabrication de verre et d'articles en verre",
  "2311": "Fabrication de verre plat",
  "2311Z": "Fabrication de verre plat",
  "2312": "Façonnage et transformation du verre plat",
  "2312Z": "Façonnage et transformation du verre plat",
  "2313": "Fabrication de verre creux",
  "2313Z": "Fabrication de verre creux",
  "2314": "Fabrication de fibres de verre",
  "2314Z": "Fabrication de fibres de verre",
  "2319":
    "Fabrication et façonnage d'autres articles en verre, y compris verre technique",
  "2319Z":
    "Fabrication et façonnage d'autres articles en verre, y compris verre technique",
  "232": "Fabrication de produits réfractaires",
  "2320": "Fabrication de produits réfractaires",
  "2320Z": "Fabrication de produits réfractaires",
  "233": "Fabrication de matériaux de construction en terre cuite",
  "2331": "Fabrication de carreaux en céramique",
  "2331Z": "Fabrication de carreaux en céramique",
  "2332":
    "Fabrication de briques, tuiles et produits de construction, en terre cuite",
  "2332Z":
    "Fabrication de briques, tuiles et produits de construction, en terre cuite",
  "234": "Fabrication d'autres produits en céramique et en porcelaine",
  "2341": "Fabrication d'articles céramiques à usage domestique ou ornemental",
  "2341Z": "Fabrication d'articles céramiques à usage domestique ou ornemental",
  "2342": "Fabrication d'appareils sanitaires en céramique",
  "2342Z": "Fabrication d'appareils sanitaires en céramique",
  "2343": "Fabrication d'isolateurs et pièces isolantes en céramique",
  "2343Z": "Fabrication d'isolateurs et pièces isolantes en céramique",
  "2344": "Fabrication d'autres produits céramiques à usage technique",
  "2344Z": "Fabrication d'autres produits céramiques à usage technique",
  "2349": "Fabrication d'autres produits céramiques",
  "2349Z": "Fabrication d'autres produits céramiques",
  "235": "Fabrication de ciment, chaux et plâtre",
  "2351": "Fabrication de ciment",
  "2351Z": "Fabrication de ciment",
  "2352": "Fabrication de chaux et plâtre",
  "2352Z": "Fabrication de chaux et plâtre",
  "236": "Fabrication d'ouvrages en béton, en ciment ou en plâtre",
  "2361": "Fabrication d'éléments en béton pour la construction",
  "2361Z": "Fabrication d'éléments en béton pour la construction",
  "2362": "Fabrication d'éléments en plâtre pour la construction",
  "2362Z": "Fabrication d'éléments en plâtre pour la construction",
  "2363": "Fabrication de béton prêt à l'emploi",
  "2363Z": "Fabrication de béton prêt à l'emploi",
  "2364": "Fabrication de mortiers et bétons secs",
  "2364Z": "Fabrication de mortiers et bétons secs",
  "2365": "Fabrication d'ouvrages en fibre-ciment",
  "2365Z": "Fabrication d'ouvrages en fibre-ciment",
  "2369": "Fabrication d'autres ouvrages en béton, en ciment ou en plâtre",
  "2369Z": "Fabrication d'autres ouvrages en béton, en ciment ou en plâtre",
  "237": "Taille, façonnage et finissage de pierres",
  "2370": "Taille, façonnage et finissage de pierres",
  "2370Z": "Taille, façonnage et finissage de pierres",
  "239":
    "Fabrication de produits abrasifs et de produits minéraux non métalliques n.c.a.",
  "2391": "Fabrication de produits abrasifs",
  "2391Z": "Fabrication de produits abrasifs",
  "2399": "Fabrication d'autres produits minéraux non métalliques n.c.a.",
  "2399Z": "Fabrication d'autres produits minéraux non métalliques n.c.a.",
  "24": "Services de soutien à l'exploitation forestière",
  "240": "Services de soutien à l'exploitation forestière",
  "241": "Sidérurgie",
  "2410": "Sidérurgie",
  "2410Z": "Sidérurgie",
  "242":
    "Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier",
  "2420":
    "Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier",
  "2420Z":
    "Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier",
  "243": "Fabrication d'autres produits de première transformation de l'acier",
  "2431": "Étirage à froid de barres",
  "2431Z": "Étirage à froid de barres",
  "2432": "Laminage à froid de feuillards",
  "2432Z": "Laminage à froid de feuillards",
  "2433": "Profilage à froid par formage ou pliage",
  "2433Z": "Profilage à froid par formage ou pliage",
  "2434": "Tréfilage à froid",
  "2434Z": "Tréfilage à froid",
  "244": "Production de métaux précieux et d'autres métaux non ferreux",
  "2441": "Production de métaux précieux",
  "2441Z": "Production de métaux précieux",
  "2442": "Métallurgie de l'aluminium",
  "2442Z": "Métallurgie de l'aluminium",
  "2443": "Métallurgie du plomb, du zinc ou de l'étain",
  "2443Z": "Métallurgie du plomb, du zinc ou de l'étain",
  "2444": "Métallurgie du cuivre",
  "2444Z": "Métallurgie du cuivre",
  "2445": "Métallurgie des autres métaux non ferreux",
  "2445Z": "Métallurgie des autres métaux non ferreux",
  "2446": "Élaboration et transformation de matières nucléaires",
  "2446Z": "Élaboration et transformation de matières nucléaires",
  "245": "Fonderie",
  "2451": "Fonderie de fonte",
  "2451Z": "Fonderie de fonte",
  "2452": "Fonderie d'acier",
  "2452Z": "Fonderie d'acier",
  "2453": "Fonderie de métaux légers",
  "2453Z": "Fonderie de métaux légers",
  "2454": "Fonderie d'autres métaux non ferreux",
  "2454Z": "Fonderie d'autres métaux non ferreux",
  "25": "Fabrication de produits métalliques, à l’exception des machines et des équipements",
  "251": "Fabrication d'éléments en métal pour la construction",
  "2511": "Fabrication de structures métalliques et de parties de structures",
  "2511Z": "Fabrication de structures métalliques et de parties de structures",
  "2512": "Fabrication de portes et fenêtres en métal",
  "2512Z": "Fabrication de portes et fenêtres en métal",
  "252": "Fabrication de réservoirs, citernes et conteneurs métalliques",
  "2521":
    "Fabrication de radiateurs et de chaudières pour le chauffage central",
  "2521Z":
    "Fabrication de radiateurs et de chaudières pour le chauffage central",
  "2529": "Fabrication d'autres réservoirs, citernes et conteneurs métalliques",
  "2529Z":
    "Fabrication d'autres réservoirs, citernes et conteneurs métalliques",
  "253":
    "Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
  "2530":
    "Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
  "2530Z":
    "Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
  "254": "Fabrication d'armes et de munitions",
  "2540": "Fabrication d'armes et de munitions",
  "2540Z": "Fabrication d'armes et de munitions",
  "255": "Forge, emboutissage, estampage ; métallurgie des poudres",
  "2550": "Forge, emboutissage, estampage ; métallurgie des poudres",
  "2550A": "Forge, estampage, matriçage ; métallurgie des poudres",
  "2550B": "Découpage, emboutissage",
  "256": "Traitement et revêtement des métaux ; usinage",
  "2561": "Traitement et revêtement des métaux",
  "2561Z": "Traitement et revêtement des métaux",
  "2562": "Usinage",
  "2562A": "Décolletage",
  "2562B": "Mécanique industrielle",
  "257": "Fabrication de coutellerie, d'outillage et de quincaillerie",
  "2571": "Fabrication de coutellerie",
  "2571Z": "Fabrication de coutellerie",
  "2572": "Fabrication de serrures et de ferrures",
  "2572Z": "Fabrication de serrures et de ferrures",
  "2573": "Fabrication d'outillage",
  "2573A": "Fabrication de moules et modèles",
  "2573B": "Fabrication d'autres outillages",
  "259": "Fabrication d'autres ouvrages en métaux",
  "2591": "Fabrication de fûts et emballages métalliques similaires",
  "2591Z": "Fabrication de fûts et emballages métalliques similaires",
  "2592": "Fabrication d'emballages métalliques légers",
  "2592Z": "Fabrication d'emballages métalliques légers",
  "2593":
    "Fabrication d'articles en fils métalliques, de chaînes et de ressorts",
  "2593Z":
    "Fabrication d'articles en fils métalliques, de chaînes et de ressorts",
  "2594": "Fabrication de vis et de boulons",
  "2594Z": "Fabrication de vis et de boulons",
  "2599": "Fabrication d'autres produits métalliques n.c.a.",
  "2599A": "Fabrication d'articles métalliques ménagers",
  "2599B": "Fabrication d'autres articles métalliques",
  "26": "Fabrication de produits informatiques, électroniques et optiques",
  "261": "Fabrication de composants et cartes électroniques",
  "2611": "Fabrication de composants électroniques",
  "2611Z": "Fabrication de composants électroniques",
  "2612": "Fabrication de cartes électroniques assemblées",
  "2612Z": "Fabrication de cartes électroniques assemblées",
  "262": "Fabrication d'ordinateurs et d'équipements périphériques",
  "2620": "Fabrication d'ordinateurs et d'équipements périphériques",
  "2620Z": "Fabrication d'ordinateurs et d'équipements périphériques",
  "263": "Fabrication d'équipements de communication",
  "2630": "Fabrication d'équipements de communication",
  "2630Z": "Fabrication d'équipements de communication",
  "264": "Fabrication de produits électroniques grand public",
  "2640": "Fabrication de produits électroniques grand public",
  "2640Z": "Fabrication de produits électroniques grand public",
  "265":
    "Fabrication d'instruments et d'appareils de mesure, d'essai et de navigation ; horlogerie",
  "2651":
    "Fabrication d'instruments et d'appareils de mesure, d'essai et de navigation",
  "2651A": "Fabrication d'équipements d'aide à la navigation",
  "2651B": "Fabrication d'instrumentation scientifique et technique",
  "2652": "Horlogerie",
  "2652Z": "Horlogerie",
  "266":
    "Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques",
  "2660":
    "Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques",
  "2660Z":
    "Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques",
  "267": "Fabrication de matériels optique et photographique",
  "2670": "Fabrication de matériels optique et photographique",
  "2670Z": "Fabrication de matériels optique et photographique",
  "268": "Fabrication de supports magnétiques et optiques",
  "2680": "Fabrication de supports magnétiques et optiques",
  "2680Z": "Fabrication de supports magnétiques et optiques",
  "27": "Fabrication d'équipements électriques",
  "271":
    "Fabrication de moteurs, génératrices et transformateurs électriques et de matériel de distribution et de commande électrique",
  "2711": "Fabrication de moteurs, génératrices et transformateurs électriques",
  "2711Z":
    "Fabrication de moteurs, génératrices et transformateurs électriques",
  "2712": "Fabrication de matériel de distribution et de commande électrique",
  "2712Z": "Fabrication de matériel de distribution et de commande électrique",
  "272": "Fabrication de piles et d'accumulateurs électriques",
  "2720": "Fabrication de piles et d'accumulateurs électriques",
  "2720Z": "Fabrication de piles et d'accumulateurs électriques",
  "273":
    "Fabrication de fils et câbles et de matériel d'installation électrique",
  "2731": "Fabrication de câbles de fibres optiques",
  "2731Z": "Fabrication de câbles de fibres optiques",
  "2732": "Fabrication d'autres fils et câbles électroniques ou électriques",
  "2732Z": "Fabrication d'autres fils et câbles électroniques ou électriques",
  "2733": "Fabrication de matériel d'installation électrique",
  "2733Z": "Fabrication de matériel d'installation électrique",
  "274": "Fabrication d'appareils d'éclairage électrique",
  "2740": "Fabrication d'appareils d'éclairage électrique",
  "2740Z": "Fabrication d'appareils d'éclairage électrique",
  "275": "Fabrication d'appareils ménagers",
  "2751": "Fabrication d'appareils électroménagers",
  "2751Z": "Fabrication d'appareils électroménagers",
  "2752": "Fabrication d'appareils ménagers non électriques",
  "2752Z": "Fabrication d'appareils ménagers non électriques",
  "279": "Fabrication d'autres matériels électriques",
  "2790": "Fabrication d'autres matériels électriques",
  "2790Z": "Fabrication d'autres matériels électriques",
  "28": "Fabrication de machines et équipements n.c.a.",
  "281": "Fabrication de machines d'usage général",
  "2811":
    "Fabrication de moteurs et turbines, à l'exception des moteurs d’avions et de véhicules",
  "2811Z":
    "Fabrication de moteurs et turbines, à l'exception des moteurs d’avions et de véhicules",
  "2812": "Fabrication d'équipements hydrauliques et pneumatiques",
  "2812Z": "Fabrication d'équipements hydrauliques et pneumatiques",
  "2813": "Fabrication d'autres pompes et compresseurs",
  "2813Z": "Fabrication d'autres pompes et compresseurs",
  "2814": "Fabrication d'autres articles de robinetterie",
  "2814Z": "Fabrication d'autres articles de robinetterie",
  "2815": "Fabrication d'engrenages et d'organes mécaniques de transmission",
  "2815Z": "Fabrication d'engrenages et d'organes mécaniques de transmission",
  "282": "Fabrication d'autres machines d'usage général",
  "2821": "Fabrication de fours et brûleurs",
  "2821Z": "Fabrication de fours et brûleurs",
  "2822": "Fabrication de matériel de levage et de manutention",
  "2822Z": "Fabrication de matériel de levage et de manutention",
  "2823":
    "Fabrication de machines et d'équipements de bureau (à l'exception des ordinateurs et équipements périphériques)",
  "2823Z":
    "Fabrication de machines et d'équipements de bureau (à l'exception des ordinateurs et équipements périphériques)",
  "2824": "Fabrication d'outillage portatif à moteur incorporé",
  "2824Z": "Fabrication d'outillage portatif à moteur incorporé",
  "2825": "Fabrication d'équipements aérauliques et frigorifiques industriels",
  "2825Z": "Fabrication d'équipements aérauliques et frigorifiques industriels",
  "2829": "Fabrication de machines diverses d'usage général",
  "2829A":
    "Fabrication d'équipements d'emballage, de conditionnement et de pesage",
  "2829B": "Fabrication d'autres machines d'usage général",
  "283": "Fabrication de machines agricoles et forestières",
  "2830": "Fabrication de machines agricoles et forestières",
  "2830Z": "Fabrication de machines agricoles et forestières",
  "284": "Fabrication de machines de formage des métaux et de machines-outils",
  "2841": "Fabrication de machines de formage des métaux",
  "2841Z": "Fabrication de machines-outils pour le travail des métaux",
  "2849": "Fabrication d'autres machines-outils",
  "2849Z": "Fabrication d'autres machines-outils",
  "289": "Fabrication d'autres machines d'usage spécifique",
  "2891": "Fabrication de machines pour la métallurgie",
  "2891Z": "Fabrication de machines pour la métallurgie",
  "2892": "Fabrication de machines pour l'extraction ou la construction",
  "2892Z": "Fabrication de machines pour l'extraction ou la construction",
  "2893": "Fabrication de machines pour l'industrie agro-alimentaire",
  "2893Z": "Fabrication de machines pour l'industrie agro-alimentaire",
  "2894": "Fabrication de machines pour les industries textiles",
  "2894Z": "Fabrication de machines pour les industries textiles",
  "2895": "Fabrication de machines pour les industries du papier et du carton",
  "2895Z": "Fabrication de machines pour les industries du papier et du carton",
  "2896":
    "Fabrication de machines pour le travail du caoutchouc ou des plastiques",
  "2896Z":
    "Fabrication de machines pour le travail du caoutchouc ou des plastiques",
  "2899": "Fabrication d'autres machines d'usage spécifique n.c.a.",
  "2899A": "Fabrication de machines d'imprimerie",
  "2899B": "Fabrication d'autres machines spécialisées",
  "29": "Industrie automobile",
  "291": "Construction de véhicules automobiles",
  "2910": "Construction de véhicules automobiles",
  "2910Z": "Construction de véhicules automobiles",
  "292": "Fabrication de carrosseries et remorques",
  "2920": "Fabrication de carrosseries et remorques",
  "2920Z": "Fabrication de carrosseries et remorques",
  "293": "Fabrication d'équipements automobiles",
  "2931": "Fabrication d'équipements électriques et électroniques automobiles",
  "2931Z": "Fabrication d'équipements électriques et électroniques automobiles",
  "2932": "Fabrication d'autres équipements automobiles",
  "2932Z": "Fabrication d'autres équipements automobiles",
  "30": "Fabrication d'autres matériels de transport",
  "301": "Construction navale",
  "3011": "Construction de navires et de structures flottantes",
  "3011Z": "Construction de navires et de structures flottantes",
  "3012": "Construction de bateaux de plaisance",
  "3012Z": "Construction de bateaux de plaisance",
  "302": "Construction de locomotives et d'autre matériel ferroviaire roulant",
  "3020": "Construction de locomotives et d'autre matériel ferroviaire roulant",
  "3020Z":
    "Construction de locomotives et d'autre matériel ferroviaire roulant",
  "303": "Construction aéronautique et spatiale",
  "3030": "Construction aéronautique et spatiale",
  "3030Z": "Construction aéronautique et spatiale",
  "304": "Construction de véhicules militaires de combat",
  "3040": "Construction de véhicules militaires de combat",
  "3040Z": "Construction de véhicules militaires de combat",
  "309": "Fabrication de matériels de transport n.c.a.",
  "3091": "Fabrication de motocycles",
  "3091Z": "Fabrication de motocycles",
  "3092": "Fabrication de bicyclettes et de véhicules pour invalides",
  "3092Z": "Fabrication de bicyclettes et de véhicules pour invalides",
  "3099": "Fabrication d’autres équipements de transport n.c.a.",
  "3099Z": "Fabrication d’autres équipements de transport n.c.a.",
  "31": "Pêche",
  "310": "Fabrication de meubles",
  "3101": "Fabrication de meubles de bureau et de magasin",
  "3101Z": "Fabrication de meubles de bureau et de magasin",
  "3102": "Fabrication de meubles de cuisine",
  "3102Z": "Fabrication de meubles de cuisine",
  "3103": "Fabrication de matelas",
  "3103Z": "Fabrication de matelas",
  "3109": "Fabrication d'autres meubles",
  "3109A": "Fabrication de sièges d'ameublement d'intérieur",
  "3109B":
    "Fabrication d’autres meubles et industries connexes de l’ameublement",
  "311": "Pêche en mer",
  "312": "Pêche en eau douce",
  "32": "Aquaculture",
  "321": "Aquaculture en mer",
  "3211": "Frappe de monnaie",
  "3211Z": "Frappe de monnaie",
  "3212": "Fabrication d’articles de joaillerie et bijouterie",
  "3212Z": "Fabrication d’articles de joaillerie et bijouterie",
  "3213":
    "Fabrication d’articles de bijouterie fantaisie et articles similaires",
  "3213Z":
    "Fabrication d’articles de bijouterie fantaisie et articles similaires",
  "322": "Fabrication d'instruments de musique",
  "3220": "Fabrication d'instruments de musique",
  "3220Z": "Fabrication d'instruments de musique",
  "323": "Fabrication d'articles de sport",
  "3230": "Fabrication d'articles de sport",
  "3230Z": "Fabrication d'articles de sport",
  "324": "Fabrication de jeux et jouets",
  "3240": "Fabrication de jeux et jouets",
  "3240Z": "Fabrication de jeux et jouets",
  "325":
    "Fabrication d'instruments et de fournitures à usage médical et dentaire",
  "3250":
    "Fabrication d'instruments et de fournitures à usage médical et dentaire",
  "3250A": "Fabrication de matériel médico-chirurgical et dentaire",
  "3250B": "Fabrication de lunettes",
  "329": "Activités manufacturières n.c.a.",
  "3291": "Fabrication d’articles de brosserie",
  "3291Z": "Fabrication d’articles de brosserie",
  "3299": "Autres activités manufacturières n.c.a.",
  "3299Z": "Autres activités manufacturières n.c.a.",
  "33": "Réparation et installation de machines et d'équipements",
  "331": "Réparation d'ouvrages en métaux, de machines et d'équipements",
  "3311": "Réparation d'ouvrages en métaux",
  "3311Z": "Réparation d'ouvrages en métaux",
  "3312": "Réparation de machines et équipements mécaniques",
  "3312Z": "Réparation de machines et équipements mécaniques",
  "3313": "Réparation de matériels électroniques et optiques",
  "3313Z": "Réparation de matériels électroniques et optiques",
  "3314": "Réparation d'équipements électriques",
  "3314Z": "Réparation d'équipements électriques",
  "3315": "Réparation et maintenance navale",
  "3315Z": "Réparation et maintenance navale",
  "3316": "Réparation et maintenance d'aéronefs et d'engins spatiaux",
  "3316Z": "Réparation et maintenance d'aéronefs et d'engins spatiaux",
  "3317": "Réparation et maintenance d'autres équipements de transport",
  "3317Z": "Réparation et maintenance d'autres équipements de transport",
  "3319": "Réparation d'autres équipements",
  "3319Z": "Réparation d'autres équipements",
  "332": "Installation de machines et d'équipements industriels",
  "3320": "Installation de machines et d'équipements industriels",
  "3320A":
    "Installation de structures métalliques, chaudronnées et de tuyauterie",
  "3320B": "Installation de machines et équipements mécaniques",
  "3320C":
    "Conception d'ensemble et assemblage sur site industriel d'équipements de contrôle des processus industriels",
  "3320D":
    "Installation d'équipements électriques, de matériels électroniques et optiques ou d'autres matériels",
  "35": "Production et distribution d'électricité, de gaz, de vapeur et d'air conditionné",
  "351": "Production, transport et distribution d'électricité",
  "3511": "Production d'électricité",
  "3511Z": "Production d'électricité",
  "3512": "Transport d'électricité",
  "3512Z": "Transport d'électricité",
  "3513": "Distribution d'électricité",
  "3513Z": "Distribution d'électricité",
  "3514": "Commerce d'électricité",
  "3514Z": "Commerce d'électricité",
  "352": "Production et distribution de combustibles gazeux",
  "3521": "Production de combustibles gazeux",
  "3521Z": "Production de combustibles gazeux",
  "3522": "Distribution de combustibles gazeux par conduites",
  "3522Z": "Distribution de combustibles gazeux par conduites",
  "3523": "Commerce de combustibles gazeux par conduites",
  "3523Z": "Commerce de combustibles gazeux par conduites",
  "353": "Production et distribution de vapeur et d'air conditionné",
  "3530": "Production et distribution de vapeur et d'air conditionné",
  "3530Z": "Production et distribution de vapeur et d'air conditionné",
  "36": "Captage, traitement et distribution d'eau",
  "360": "Captage, traitement et distribution d'eau",
  "3600": "Captage, traitement et distribution d'eau",
  "3600Z": "Captage, traitement et distribution d'eau",
  "37": "Collecte et traitement des eaux usées",
  "370": "Collecte et traitement des eaux usées",
  "3700": "Collecte et traitement des eaux usées",
  "3700Z": "Collecte et traitement des eaux usées",
  "38": "Collecte, traitement et élimination des déchets ; récupération",
  "381": "Collecte des déchets",
  "3811": "Collecte des déchets non dangereux",
  "3811Z": "Collecte des déchets non dangereux",
  "3812": "Collecte des déchets dangereux",
  "3812Z": "Collecte des déchets dangereux",
  "382": "Traitement et élimination des déchets",
  "3821": "Traitement et élimination des déchets non dangereux",
  "3821Z": "Traitement et élimination des déchets non dangereux",
  "3822": "Traitement et élimination des déchets dangereux",
  "3822Z": "Traitement et élimination des déchets dangereux",
  "383": "Récupération",
  "3831": "Démantèlement d'épaves",
  "3831Z": "Démantèlement d'épaves",
  "3832": "Récupération de déchets triés",
  "3832Z": "Récupération de déchets triés",
  "39": "Dépollution et autres services de gestion des déchets",
  "390": "Dépollution et autres services de gestion des déchets",
  "3900": "Dépollution et autres services de gestion des déchets",
  "3900Z": "Dépollution et autres services de gestion des déchets",
  "41": "Construction de bâtiments",
  "411": "Promotion immobilière",
  "4110": "Promotion immobilière",
  "4110A": "Promotion immobilière de logements",
  "4110B": "Promotion immobilière de bureaux",
  "4110C": "Promotion immobilière d'autres bâtiments",
  "4110D": "Supports juridiques de programmes",
  "412": "Construction de bâtiments résidentiels et non résidentiels",
  "4120": "Construction de bâtiments résidentiels et non résidentiels",
  "4120A": "Construction de maisons individuelles",
  "4120B": "Construction d'autres bâtiments",
  "42": "Génie civil",
  "421": "Construction de routes et de voies ferrées",
  "4211": "Construction de routes et autoroutes",
  "4211Z": "Construction de routes et autoroutes",
  "4212": "Construction de voies ferrées de surface et souterraines",
  "4212Z": "Construction de voies ferrées de surface et souterraines",
  "4213": "Construction de ponts et tunnels",
  "4213A": "Construction d'ouvrages d'art",
  "4213B": "Construction et entretien de tunnels",
  "422": "Construction de réseaux et de lignes",
  "4221": "Construction de réseaux pour fluides",
  "4221Z": "Construction de réseaux pour fluides",
  "4222": "Construction de réseaux électriques et de télécommunications",
  "4222Z": "Construction de réseaux électriques et de télécommunications",
  "429": "Construction d'autres ouvrages de génie civil",
  "4291": "Construction d'ouvrages maritimes et fluviaux",
  "4291Z": "Construction d'ouvrages maritimes et fluviaux",
  "4299": "Construction d'autres ouvrages de génie civil n.c.a.",
  "4299Z": "Construction d'autres ouvrages de génie civil n.c.a.",
  "43": "Travaux de construction spécialisés",
  "431": "Démolition et préparation des sites",
  "4311": "Travaux de démolition",
  "4311Z": "Travaux de démolition",
  "4312": "Travaux de préparation des sites",
  "4312A": "Travaux de terrassement courants et travaux préparatoires",
  "4312B": "Travaux de terrassement spécialisés ou de grande masse",
  "4313": "Forages et sondages",
  "4313Z": "Forages et sondages",
  "432":
    "Travaux d'installation électrique, plomberie et autres travaux d'installation",
  "4321": "Installation électrique",
  "4321A": "Travaux d'installation électrique dans tous locaux",
  "4321B": "Travaux d'installation électrique sur la voie publique",
  "4322":
    "Travaux de plomberie et installation de chauffage et de conditionnement d'air",
  "4322A": "Travaux d'installation d'eau et de gaz en tous locaux",
  "4322B":
    "Travaux d'installation d'équipements thermiques et de climatisation",
  "4329": "Autres travaux d'installation",
  "4329A": "Travaux d'isolation",
  "4329B": "Autres travaux d'installation n.c.a.",
  "433": "Travaux de finition",
  "4331": "Travaux de plâtrerie",
  "4331Z": "Travaux de plâtrerie",
  "4332": "Travaux de menuiserie",
  "4332A": "Travaux de menuiserie bois et PVC",
  "4332B": "Travaux de menuiserie métallique et serrurerie",
  "4332C": "Agencement de lieux de vente",
  "4333": "Travaux de revêtement des sols et des murs",
  "4333Z": "Travaux de revêtement des sols et des murs",
  "4334": "Travaux de peinture et vitrerie",
  "4334Z": "Travaux de peinture et vitrerie",
  "4339": "Autres travaux de finition",
  "4339Z": "Autres travaux de finition",
  "439": "Autres travaux de construction spécialisés",
  "4391": "Travaux de couverture",
  "4391A": "Travaux de charpente",
  "4391B": "Travaux de couverture par éléments",
  "4399": "Autres travaux de construction spécialisés n.c.a.",
  "4399A": "Travaux d'étanchéification",
  "4399B": "Travaux de montage de structures métalliques",
  "4399C": "Travaux de maçonnerie générale et gros œuvre de bâtiment",
  "4399D": "Autres travaux spécialisés de construction",
  "4399E": "Location avec opérateur de matériel de construction",
  "45": "Commerce et réparation d'automobiles et de motocycles",
  "451": "Commerce de véhicules automobiles",
  "4511": "Commerce de voitures et de véhicules automobiles légers",
  "4511Z": "Commerce de voitures et de véhicules automobiles légers",
  "4519": "Commerce d'autres véhicules automobiles",
  "4519Z": "Commerce d'autres véhicules automobiles",
  "452": "Entretien et réparation de véhicules automobiles",
  "4520": "Entretien et réparation de véhicules automobiles",
  "4520A": "Entretien et réparation de véhicules automobiles légers",
  "4520B": "Entretien et réparation d'autres véhicules automobiles",
  "453": "Commerce d'équipements automobiles",
  "4531": "Commerce de gros d'équipements automobiles",
  "4531Z": "Commerce de gros d'équipements automobiles",
  "4532": "Commerce de détail d'équipements automobiles",
  "4532Z": "Commerce de détail d'équipements automobiles",
  "454": "Commerce et réparation de motocycles",
  "4540": "Commerce et réparation de motocycles",
  "4540Z": "Commerce et réparation de motocycles",
  "46": "Commerce de gros, à l’exception des automobiles et des motocycles",
  "461": "Intermédiaires du commerce de gros",
  "4611":
    "Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis",
  "4611Z":
    "Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis",
  "4612":
    "Intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques",
  "4612A": "Centrales d'achat de carburant",
  "4612B":
    "Autres intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques",
  "4613": "Intermédiaires du commerce en bois et matériaux de construction",
  "4613Z": "Intermédiaires du commerce en bois et matériaux de construction",
  "4614":
    "Intermédiaires du commerce en machines, équipements industriels, navires et avions",
  "4614Z":
    "Intermédiaires du commerce en machines, équipements industriels, navires et avions",
  "4615":
    "Intermédiaires du commerce en meubles, articles de ménage et quincaillerie",
  "4615Z":
    "Intermédiaires du commerce en meubles, articles de ménage et quincaillerie",
  "4616":
    "Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir",
  "4616Z":
    "Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir",
  "4617": "Intermédiaires du commerce en denrées, boissons et tabac",
  "4617A": "Centrales d'achat alimentaires",
  "4617B": "Autres intermédiaires du commerce en denrées, boissons et tabac",
  "4618":
    "Intermédiaires spécialisés dans le commerce d'autres produits spécifiques",
  "4618Z":
    "Intermédiaires spécialisés dans le commerce d'autres produits spécifiques",
  "4619": "Intermédiaires du commerce en produits divers",
  "4619A": "Centrales d'achat non alimentaires",
  "4619B": "Autres intermédiaires du commerce en produits divers",
  "462": "Commerce de gros de produits agricoles bruts et d'animaux vivants",
  "4621":
    "Commerce de gros de céréales, de tabac non manufacturé, de semences et d'aliments pour le bétail",
  "4621Z":
    "Commerce de gros (commerce interentreprises) de céréales, de tabac non manufacturé, de semences et d'aliments pour le bétail",
  "4622": "Commerce de gros de fleurs et plantes",
  "4622Z": "Commerce de gros (commerce interentreprises) de fleurs et plantes",
  "4623": "Commerce de gros d'animaux vivants",
  "4623Z": "Commerce de gros (commerce interentreprises) d'animaux vivants",
  "4624": "Commerce de gros de cuirs et peaux",
  "4624Z": "Commerce de gros (commerce interentreprises) de cuirs et peaux",
  "463": "Commerce de gros de produits alimentaires, de boissons et de tabac",
  "4631": "Commerce de gros de fruits et légumes",
  "4631Z": "Commerce de gros (commerce interentreprises) de fruits et légumes",
  "4632": "Commerce de gros de viandes et de produits à base de viande",
  "4632A":
    "Commerce de gros (commerce interentreprises) de viandes de boucherie",
  "4632B":
    "Commerce de gros (commerce interentreprises) de produits à base de viande",
  "4632C":
    "Commerce de gros (commerce interentreprises) de volailles et gibier",
  "4633":
    "Commerce de gros de produits laitiers, œufs, huiles et matières grasses comestibles",
  "4633Z":
    "Commerce de gros (commerce interentreprises) de produits laitiers, œufs, huiles et matières grasses comestibles",
  "4634": "Commerce de gros de boissons",
  "4634Z": "Commerce de gros (commerce interentreprises) de boissons",
  "4635": "Commerce de gros de produits à base de tabac",
  "4635Z":
    "Commerce de gros (commerce interentreprises) de produits à base de tabac",
  "4636": "Commerce de gros de sucre, chocolat et confiserie",
  "4636Z":
    "Commerce de gros (commerce interentreprises) de sucre, chocolat et confiserie",
  "4637": "Commerce de gros de café, thé, cacao et épices",
  "4637Z":
    "Commerce de gros (commerce interentreprises) de café, thé, cacao et épices",
  "4638":
    "Commerce de gros d'autres produits alimentaires, y compris poissons, crustacés et mollusques",
  "4638A":
    "Commerce de gros (commerce interentreprises) de poissons, crustacés et mollusques",
  "4638B":
    "Commerce de gros (commerce interentreprises) alimentaire spécialisé divers",
  "4639": "Commerce de gros non spécialisé de denrées, boissons et tabac",
  "4639A": "Commerce de gros (commerce interentreprises) de produits surgelés",
  "4639B":
    "Commerce de gros (commerce interentreprises) alimentaire non spécialisé",
  "464": "Commerce de gros de biens domestiques",
  "4641": "Commerce de gros de textiles",
  "4641Z": "Commerce de gros (commerce interentreprises) de textiles",
  "4642": "Commerce de gros d'habillement et de chaussures",
  "4642Z":
    "Commerce de gros (commerce interentreprises) d'habillement et de chaussures",
  "4643": "Commerce de gros d'appareils électroménagers",
  "4643Z":
    "Commerce de gros (commerce interentreprises) d'appareils électroménagers",
  "4644": "Commerce de gros de vaisselle, verrerie et produits d'entretien",
  "4644Z":
    "Commerce de gros (commerce interentreprises) de vaisselle, verrerie et produits d'entretien",
  "4645": "Commerce de gros de parfumerie et de produits de beauté",
  "4645Z":
    "Commerce de gros (commerce interentreprises) de parfumerie et de produits de beauté",
  "4646": "Commerce de gros de produits pharmaceutiques",
  "4646Z":
    "Commerce de gros (commerce interentreprises) de produits pharmaceutiques",
  "4647": "Commerce de gros de meubles, de tapis et d'appareils d'éclairage",
  "4647Z":
    "Commerce de gros (commerce interentreprises) de meubles, de tapis et d'appareils d'éclairage",
  "4648": "Commerce de gros d'articles d'horlogerie et de bijouterie",
  "4648Z":
    "Commerce de gros (commerce interentreprises) d'articles d'horlogerie et de bijouterie",
  "4649": "Commerce de gros d'autres biens domestiques",
  "4649Z":
    "Commerce de gros (commerce interentreprises) d'autres biens domestiques",
  "465":
    "Commerce de gros d'équipements de l'information et de la communication",
  "4651":
    "Commerce de gros d'ordinateurs, d'équipements informatiques périphériques et de logiciels",
  "4651Z":
    "Commerce de gros (commerce interentreprises) d'ordinateurs, d'équipements informatiques périphériques et de logiciels",
  "4652":
    "Commerce de gros de composants et d'équipements électroniques et de télécommunication",
  "4652Z":
    "Commerce de gros (commerce interentreprises) de composants et d'équipements électroniques et de télécommunication",
  "466": "Commerce de gros d'autres équipements industriels",
  "4661": "Commerce de gros de matériel agricole",
  "4661Z": "Commerce de gros (commerce interentreprises) de matériel agricole",
  "4662": "Commerce de gros de machines-outils",
  "4662Z": "Commerce de gros (commerce interentreprises) de machines-outils",
  "4663":
    "Commerce de gros de machines pour l'extraction, la construction et le génie civil",
  "4663Z":
    "Commerce de gros (commerce interentreprises) de machines pour l'extraction, la construction et le génie civil",
  "4664":
    "Commerce de gros de machines pour l'industrie textile et l'habillement",
  "4664Z":
    "Commerce de gros (commerce interentreprises) de machines pour l'industrie textile et l'habillement",
  "4665": "Commerce de gros de mobilier de bureau",
  "4665Z": "Commerce de gros (commerce interentreprises) de mobilier de bureau",
  "4666": "Commerce de gros d'autres machines et équipements de bureau",
  "4666Z":
    "Commerce de gros (commerce interentreprises) d'autres machines et équipements de bureau",
  "4669": "Commerce de gros d'autres machines et équipements",
  "4669A":
    "Commerce de gros (commerce interentreprises) de matériel électrique",
  "4669B":
    "Commerce de gros (commerce interentreprises) de fournitures et équipements industriels divers",
  "4669C":
    "Commerce de gros (commerce interentreprises) de fournitures et équipements divers pour le commerce et les services",
  "467": "Autres commerces de gros spécialisés",
  "4671": "Commerce de gros de combustibles et de produits annexes",
  "4671Z":
    "Commerce de gros (commerce interentreprises) de combustibles et de produits annexes",
  "4672": "Commerce de gros de minerais et métaux",
  "4672Z": "Commerce de gros (commerce interentreprises) de minerais et métaux",
  "4673":
    "Commerce de gros de bois, de matériaux de construction et d'appareils sanitaires",
  "4673A":
    "Commerce de gros (commerce interentreprises) de bois et de matériaux de construction",
  "4673B":
    "Commerce de gros (commerce interentreprises) d'appareils sanitaires et de produits de décoration",
  "4674":
    "Commerce de gros de quincaillerie et fournitures pour plomberie et chauffage",
  "4674A": "Commerce de gros (commerce interentreprises) de quincaillerie",
  "4674B":
    "Commerce de gros (commerce interentreprises) de fournitures pour la plomberie et le chauffage",
  "4675": "Commerce de gros de produits chimiques",
  "4675Z": "Commerce de gros (commerce interentreprises) de produits chimiques",
  "4676": "Commerce de gros d'autres produits intermédiaires",
  "4676Z":
    "Commerce de gros (commerce interentreprises) d'autres produits intermédiaires",
  "4677": "Commerce de gros de déchets et débris",
  "4677Z": "Commerce de gros (commerce interentreprises) de déchets et débris",
  "469": "Commerce de gros non spécialisé",
  "4690": "Commerce de gros non spécialisé",
  "4690Z": "Commerce de gros (commerce interentreprises) non spécialisé",
  "47": "Commerce de détail, à l’exception des automobiles et des motocycles",
  "471": "Commerce de détail en magasin non spécialisé",
  "4711":
    "Commerce de détail en magasin non spécialisé à prédominance alimentaire",
  "4711A": "Commerce de détail de produits surgelés",
  "4711B": "Commerce d'alimentation générale",
  "4711C": "Supérettes",
  "4711D": "Supermarchés",
  "4711E": "Magasins multi-commerces",
  "4711F": "Hypermarchés",
  "4719": "Autre commerce de détail en magasin non spécialisé",
  "4719A": "Grands magasins",
  "4719B": "Autres commerces de détail en magasin non spécialisé",
  "472": "Commerce de détail alimentaire en magasin spécialisé",
  "4721": "Commerce de détail de fruits et légumes en magasin spécialisé",
  "4721Z": "Commerce de détail de fruits et légumes en magasin spécialisé",
  "4722":
    "Commerce de détail de viandes et de produits à base de viande en magasin spécialisé",
  "4722Z":
    "Commerce de détail de viandes et de produits à base de viande en magasin spécialisé",
  "4723":
    "Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé",
  "4723Z":
    "Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé",
  "4724":
    "Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé",
  "4724Z":
    "Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé",
  "4725": "Commerce de détail de boissons en magasin spécialisé",
  "4725Z": "Commerce de détail de boissons en magasin spécialisé",
  "4726":
    "Commerce de détail de produits à base de tabac en magasin spécialisé",
  "4726Z":
    "Commerce de détail de produits à base de tabac en magasin spécialisé",
  "4729": "Autres commerces de détail alimentaires en magasin spécialisé",
  "4729Z": "Autres commerces de détail alimentaires en magasin spécialisé",
  "473": "Commerce de détail de carburants en magasin spécialisé",
  "4730": "Commerce de détail de carburants en magasin spécialisé",
  "4730Z": "Commerce de détail de carburants en magasin spécialisé",
  "474":
    "Commerce de détail d'équipements de l'information et de la communication en magasin spécialisé",
  "4741":
    "Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé",
  "4741Z":
    "Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé",
  "4742":
    "Commerce de détail de matériels de télécommunication en magasin spécialisé",
  "4742Z":
    "Commerce de détail de matériels de télécommunication en magasin spécialisé",
  "4743": "Commerce de détail de matériels audio/vidéo en magasin spécialisé",
  "4743Z":
    "Commerce de détail de matériels audio et vidéo en magasin spécialisé",
  "475":
    "Commerce de détail d'autres équipements du foyer en magasin spécialisé",
  "4751": "Commerce de détail de textiles en magasin spécialisé",
  "4751Z": "Commerce de détail de textiles en magasin spécialisé",
  "4752":
    "Commerce de détail de quincaillerie, peintures et verres en magasin spécialisé",
  "4752A":
    "Commerce de détail de quincaillerie, peintures et verres en petites surfaces (moins de 400 m2)",
  "4752B":
    "Commerce de détail de quincaillerie, peintures et verres en grandes surfaces (400 m2et plus)",
  "4753":
    "Commerce de détail de tapis, moquettes et revêtements de murs et de sols en magasin spécialisé",
  "4753Z":
    "Commerce de détail de tapis, moquettes et revêtements de murs et de sols en magasin spécialisé",
  "4754":
    "Commerce de détail d'appareils électroménagers en magasin spécialisé",
  "4754Z":
    "Commerce de détail d'appareils électroménagers en magasin spécialisé",
  "4759":
    "Commerce de détail de meubles, appareils d'éclairage et autres articles de ménage en magasin spécialisé",
  "4759A": "Commerce de détail de meubles",
  "4759B": "Commerce de détail d'autres équipements du foyer",
  "476":
    "Commerce de détail de biens culturels et de loisirs en magasin spécialisé",
  "4761": "Commerce de détail de livres en magasin spécialisé",
  "4761Z": "Commerce de détail de livres en magasin spécialisé",
  "4762": "Commerce de détail de journaux et papeterie en magasin spécialisé",
  "4762Z": "Commerce de détail de journaux et papeterie en magasin spécialisé",
  "4763":
    "Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé",
  "4763Z":
    "Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé",
  "4764": "Commerce de détail d'articles de sport en magasin spécialisé",
  "4764Z": "Commerce de détail d'articles de sport en magasin spécialisé",
  "4765": "Commerce de détail de jeux et jouets en magasin spécialisé",
  "4765Z": "Commerce de détail de jeux et jouets en magasin spécialisé",
  "477": "Autres commerces de détail en magasin spécialisé",
  "4771": "Commerce de détail d'habillement en magasin spécialisé",
  "4771Z": "Commerce de détail d'habillement en magasin spécialisé",
  "4772":
    "Commerce de détail de chaussures et d'articles en cuir en magasin spécialisé",
  "4772A": "Commerce de détail de la chaussure",
  "4772B": "Commerce de détail de maroquinerie et d'articles de voyage",
  "4773":
    "Commerce de détail de produits pharmaceutiques en magasin spécialisé",
  "4773Z":
    "Commerce de détail de produits pharmaceutiques en magasin spécialisé",
  "4774":
    "Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé",
  "4774Z":
    "Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé",
  "4775":
    "Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé",
  "4775Z":
    "Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé",
  "4776":
    "Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé",
  "4776Z":
    "Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé",
  "4777":
    "Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé",
  "4777Z":
    "Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé",
  "4778": "Autre commerce de détail de biens neufs en magasin spécialisé",
  "4778A": "Commerces de détail d'optique",
  "4778B": "Commerces de détail de charbons et combustibles",
  "4778C": "Autres commerces de détail spécialisés divers",
  "4779": "Commerce de détail de biens d'occasion en magasin",
  "4779Z": "Commerce de détail de biens d'occasion en magasin",
  "478": "Commerce de détail sur éventaires et marchés",
  "4781": "Commerce de détail alimentaire sur éventaires et marchés",
  "4781Z": "Commerce de détail alimentaire sur éventaires et marchés",
  "4782":
    "Commerce de détail de textiles, d'habillement et de chaussures sur éventaires et marchés",
  "4782Z":
    "Commerce de détail de textiles, d'habillement et de chaussures sur éventaires et marchés",
  "4789": "Autres commerces de détail sur éventaires et marchés",
  "4789Z": "Autres commerces de détail sur éventaires et marchés",
  "479": "Commerce de détail hors magasin, éventaires ou marchés",
  "4791": "Vente à distance",
  "4791A": "Vente à distance sur catalogue général",
  "4791B": "Vente à distance sur catalogue spécialisé",
  "4799": "Autres commerces de détail hors magasin, éventaires ou marchés",
  "4799A": "Vente à domicile",
  "4799B":
    "Vente par automates et autres commerces de détail hors magasin, éventaires ou marchés n.c.a.",
  "49": "Transports terrestres et transport par conduites",
  "491": "Transport ferroviaire interurbain de voyageurs",
  "4910": "Transport ferroviaire interurbain de voyageurs",
  "4910Z": "Transport ferroviaire interurbain de voyageurs",
  "492": "Transports ferroviaires de fret",
  "4920": "Transports ferroviaires de fret",
  "4920Z": "Transports ferroviaires de fret",
  "493": "Autres transports terrestres de voyageurs",
  "4931": "Transports urbains et suburbains de voyageurs",
  "4931Z": "Transports urbains et suburbains de voyageurs",
  "4932": "Transports de voyageurs par taxis",
  "4932Z": "Transports de voyageurs par taxis",
  "4939": "Autres transports terrestres de voyageurs n.c.a.",
  "4939A": "Transports routiers réguliers de voyageurs",
  "4939B": "Autres transports routiers de voyageurs",
  "4939C": "Téléphériques et remontées mécaniques",
  "494": "Transports routiers de fret et services de déménagement",
  "4941": "Transports routiers de fret",
  "4941A": "Transports routiers de fret interurbains",
  "4941B": "Transports routiers de fret de proximité",
  "4941C": "Location de camions avec chauffeur",
  "4942": "Services de déménagement",
  "4942Z": "Services de déménagement",
  "495": "Transports par conduites",
  "4950": "Transports par conduites",
  "4950Z": "Transports par conduites",
  "50": "Transports par eau",
  "501": "Transports maritimes et côtiers de passagers",
  "5010": "Transports maritimes et côtiers de passagers",
  "5010Z": "Transports maritimes et côtiers de passagers",
  "502": "Transports maritimes et côtiers de fret",
  "5020": "Transports maritimes et côtiers de fret",
  "5020Z": "Transports maritimes et côtiers de fret",
  "503": "Transports fluviaux de passagers",
  "5030": "Transports fluviaux de passagers",
  "5030Z": "Transports fluviaux de passagers",
  "504": "Transports fluviaux de fret",
  "5040": "Transports fluviaux de fret",
  "5040Z": "Transports fluviaux de fret",
  "51": "Extraction de houille",
  "510": "Extraction de houille",
  "511": "Transports aériens de passagers",
  "5110": "Transports aériens de passagers",
  "5110Z": "Transports aériens de passagers",
  "512": "Transports aériens de fret et transports spatiaux",
  "5121": "Transports aériens de fret",
  "5121Z": "Transports aériens de fret",
  "5122": "Transports spatiaux",
  "5122Z": "Transports spatiaux",
  "52": "Extraction de lignite",
  "520": "Extraction de lignite",
  "521": "Entreposage et stockage",
  "5210": "Entreposage et stockage",
  "5210A": "Entreposage et stockage frigorifique",
  "5210B": "Entreposage et stockage non frigorifique",
  "522": "Services auxiliaires des transports",
  "5221": "Services auxiliaires des transports terrestres",
  "5221Z": "Services auxiliaires des transports terrestres",
  "5222": "Services auxiliaires des transports par eau",
  "5222Z": "Services auxiliaires des transports par eau",
  "5223": "Services auxiliaires des transports aériens",
  "5223Z": "Services auxiliaires des transports aériens",
  "5224": "Manutention",
  "5224A": "Manutention portuaire",
  "5224B": "Manutention non portuaire",
  "5229": "Autres services auxiliaires des transports",
  "5229A": "Messagerie, fret express",
  "5229B": "Affrètement et organisation des transports",
  "53": "Activités de poste et de courrier",
  "531":
    "Activités de poste dans le cadre d'une obligation de service universel",
  "5310":
    "Activités de poste dans le cadre d'une obligation de service universel",
  "5310Z":
    "Activités de poste dans le cadre d'une obligation de service universel",
  "532": "Autres activités de poste et de courrier",
  "5320": "Autres activités de poste et de courrier",
  "5320Z": "Autres activités de poste et de courrier",
  "55": "Hébergement",
  "551": "Hôtels et hébergement similaire",
  "5510": "Hôtels et hébergement similaire",
  "5510Z": "Hôtels et hébergement similaire",
  "552": "Hébergement touristique et autre hébergement de courte durée",
  "5520": "Hébergement touristique et autre hébergement de courte durée",
  "5520Z": "Hébergement touristique et autre hébergement de courte durée",
  "553": "Terrains de camping et parcs pour caravanes ou véhicules de loisirs",
  "5530": "Terrains de camping et parcs pour caravanes ou véhicules de loisirs",
  "5530Z":
    "Terrains de camping et parcs pour caravanes ou véhicules de loisirs",
  "559": "Autres hébergements",
  "5590": "Autres hébergements",
  "5590Z": "Autres hébergements",
  "56": "Restauration",
  "561": "Restaurants et services de restauration mobile",
  "5610": "Restaurants et services de restauration mobile",
  "5610A": "Restauration traditionnelle",
  "5610B": "Cafétérias et autres libres-services",
  "5610C": "Restauration de type rapide",
  "562": "Traiteurs et autres services de restauration",
  "5621": "Services des traiteurs",
  "5621Z": "Services des traiteurs",
  "5629": "Autres services de restauration",
  "5629A": "Restauration collective sous contrat",
  "5629B": "Autres services de restauration n.c.a.",
  "563": "Débits de boissons",
  "5630": "Débits de boissons",
  "5630Z": "Débits de boissons",
  "58": "Édition",
  "581": "Édition de livres et périodiques et autres activités d'édition",
  "5811": "Édition de livres",
  "5811Z": "Édition de livres",
  "5812": "Édition de répertoires et de fichiers d'adresses",
  "5812Z": "Édition de répertoires et de fichiers d'adresses",
  "5813": "Édition de journaux",
  "5813Z": "Édition de journaux",
  "5814": "Édition de revues et périodiques",
  "5814Z": "Édition de revues et périodiques",
  "5819": "Autres activités d'édition",
  "5819Z": "Autres activités d'édition",
  "582": "Édition de logiciels",
  "5821": "Édition de jeux électroniques",
  "5821Z": "Édition de jeux électroniques",
  "5829": "Édition d'autres logiciels",
  "5829A": "Édition de logiciels système et de réseau",
  "5829B": "Edition de logiciels outils de développement et de langages",
  "5829C": "Edition de logiciels applicatifs",
  "59": "Production de films cinématographiques, de vidéo et de programmes de télévision ; enregistrement sonore et édition musicale",
  "591": "Activités cinématographiques, vidéo et de télévision",
  "5911":
    "Production de films cinématographiques, de vidéo et de programmes de télévision",
  "5911A": "Production de films et de programmes pour la télévision",
  "5911B": "Production de films institutionnels et publicitaires",
  "5911C": "Production de films pour le cinéma",
  "5912":
    "Post-production de films cinématographiques, de vidéo et de programmes de télévision",
  "5912Z":
    "Post-production de films cinématographiques, de vidéo et de programmes de télévision",
  "5913":
    "Distribution de films cinématographiques, de vidéo et de programmes de télévision",
  "5913A": "Distribution de films cinématographiques",
  "5913B": "Edition et distribution vidéo",
  "5914": "Projection de films cinématographiques",
  "5914Z": "Projection de films cinématographiques",
  "592": "Enregistrement sonore et édition musicale",
  "5920": "Enregistrement sonore et édition musicale",
  "5920Z": "Enregistrement sonore et édition musicale",
  "60": "Programmation et diffusion",
  "601": "Édition et diffusion de programmes radio",
  "6010": "Édition et diffusion de programmes radio",
  "6010Z": "Édition et diffusion de programmes radio",
  "602": "Programmation de télévision et télédiffusion",
  "6020": "Programmation de télévision et télédiffusion",
  "6020A": "Edition de chaînes généralistes",
  "6020B": "Edition de chaînes thématiques",
  "61": "Télécommunications",
  "610": "Extraction de pétrole brut",
  "611": "Télécommunications filaires",
  "6110": "Télécommunications filaires",
  "6110Z": "Télécommunications filaires",
  "612": "Télécommunications sans fil",
  "6120": "Télécommunications sans fil",
  "6120Z": "Télécommunications sans fil",
  "613": "Télécommunications par satellite",
  "6130": "Télécommunications par satellite",
  "6130Z": "Télécommunications par satellite",
  "619": "Autres activités de télécommunication",
  "6190": "Autres activités de télécommunication",
  "6190Z": "Autres activités de télécommunication",
  "62": "Programmation, conseil et autres activités informatiques",
  "620": "Extraction de gaz naturel",
  "6201": "Programmation informatique",
  "6201Z": "Programmation informatique",
  "6202": "Conseil informatique",
  "6202A": "Conseil en systèmes et logiciels informatiques",
  "6202B": "Tierce maintenance de systèmes et d’applications informatiques",
  "6203": "Gestion d'installations informatiques",
  "6203Z": "Gestion d'installations informatiques",
  "6209": "Autres activités informatiques",
  "6209Z": "Autres activités informatiques",
  "63": "Services d'information",
  "631":
    "Traitement de données, hébergement et activités connexes ; portails Internet",
  "6311": "Traitement de données, hébergement et activités connexes",
  "6311Z": "Traitement de données, hébergement et activités connexes",
  "6312": "Portails Internet",
  "6312Z": "Portails Internet",
  "639": "Autres services d'information",
  "6391": "Activités des agences de presse",
  "6391Z": "Activités des agences de presse",
  "6399": "Autres services d'information n.c.a.",
  "6399Z": "Autres services d'information n.c.a.",
  "64": "Activités des services financiers, hors assurance et caisses de retraite",
  "641": "Intermédiation monétaire",
  "6411": "Activités de banque centrale",
  "6411Z": "Activités de banque centrale",
  "6419": "Autres intermédiations monétaires",
  "6419Z": "Autres intermédiations monétaires",
  "642": "Activités des sociétés holding",
  "6420": "Activités des sociétés holding",
  "6420Z": "Activités des sociétés holding",
  "643": "Fonds de placement et entités financières similaires",
  "6430": "Fonds de placement et entités financières similaires",
  "6430Z": "Fonds de placement et entités financières similaires",
  "649":
    "Autres activités des services financiers, hors assurance et caisses de retraite",
  "6491": "Crédit-bail",
  "6491Z": "Crédit-bail",
  "6492": "Autre distribution de crédit",
  "6492Z": "Autre distribution de crédit",
  "6499":
    "Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.",
  "6499Z":
    "Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.",
  "65": "Assurance",
  "651": "Assurance",
  "6511": "Assurance vie",
  "6511Z": "Assurance vie",
  "6512": "Autres assurances",
  "6512Z": "Autres assurances",
  "652": "Réassurance",
  "6520": "Réassurance",
  "6520Z": "Réassurance",
  "653": "Caisses de retraite",
  "6530": "Caisses de retraite",
  "6530Z": "Caisses de retraite",
  "66": "Activités auxiliaires de services financiers et d'assurance",
  "661":
    "Activités auxiliaires de services financiers, hors assurance et caisses de retraite",
  "6611": "Administration de marchés financiers",
  "6611Z": "Administration de marchés financiers",
  "6612": "Courtage de valeurs mobilières et de marchandises",
  "6612Z": "Courtage de valeurs mobilières et de marchandises",
  "6619":
    "Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite",
  "6619A": "Supports juridiques de gestion de patrimoine mobilier",
  "6619B":
    "Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite, n.c.a.",
  "662": "Activités auxiliaires d'assurance et de caisses de retraite",
  "6621": "Évaluation des risques et dommages",
  "6621Z": "Évaluation des risques et dommages",
  "6622": "Activités des agents et courtiers d'assurances",
  "6622Z": "Activités des agents et courtiers d'assurances",
  "6629": "Autres activités auxiliaires d'assurance et de caisses de retraite",
  "6629Z": "Autres activités auxiliaires d'assurance et de caisses de retraite",
  "663": "Gestion de fonds",
  "6630": "Gestion de fonds",
  "6630Z": "Gestion de fonds",
  "68": "Activités immobilières",
  "681": "Activités des marchands de biens immobiliers",
  "6810": "Activités des marchands de biens immobiliers",
  "6810Z": "Activités des marchands de biens immobiliers",
  "682": "Location et exploitation de biens immobiliers propres ou loués",
  "6820": "Location et exploitation de biens immobiliers propres ou loués",
  "6820A": "Location de logements",
  "6820B": "Location de terrains et d'autres biens immobiliers",
  "683": "Activités immobilières pour compte de tiers",
  "6831": "Agences immobilières",
  "6831Z": "Agences immobilières",
  "6832": "Administration de biens immobiliers",
  "6832A": "Administration d'immeubles et autres biens immobiliers",
  "6832B": "Supports juridiques de gestion de patrimoine immobilier",
  "69": "Activités juridiques et comptables",
  "691": "Activités juridiques",
  "6910": "Activités juridiques",
  "6910Z": "Activités juridiques",
  "692": "Activités comptables",
  "6920": "Activités comptables",
  "6920Z": "Activités comptables",
  "70": "Activités des sièges sociaux ; conseil de gestion",
  "701": "Activités des sièges sociaux",
  "7010": "Activités des sièges sociaux",
  "7010Z": "Activités des sièges sociaux",
  "702": "Conseil de gestion",
  "7021": "Conseil en relations publiques et communication",
  "7021Z": "Conseil en relations publiques et communication",
  "7022": "Conseil pour les affaires et autres conseils de gestion",
  "7022Z": "Conseil pour les affaires et autres conseils de gestion",
  "71": "Extraction de minerais de fer",
  "710": "Extraction de minerais de fer",
  "711": "Activités d'architecture et d'ingénierie",
  "7111": "Activités d'architecture",
  "7111Z": "Activités d'architecture",
  "7112": "Activités d'ingénierie",
  "7112A": "Activité des géomètres",
  "7112B": "Ingénierie, études techniques",
  "712": "Activités de contrôle et analyses techniques",
  "7120": "Activités de contrôle et analyses techniques",
  "7120A": "Contrôle technique automobile",
  "7120B": "Analyses, essais et inspections techniques",
  "72": "Recherche-développement scientifique",
  "721": "Recherche-développement en sciences physiques et naturelles",
  "7211": "Recherche-développement en biotechnologie",
  "7211Z": "Recherche-développement en biotechnologie",
  "7219": "Recherche-développement en autres sciences physiques et naturelles",
  "7219Z": "Recherche-développement en autres sciences physiques et naturelles",
  "722": "Recherche-développement en sciences humaines et sociales",
  "7220": "Recherche-développement en sciences humaines et sociales",
  "7220Z": "Recherche-développement en sciences humaines et sociales",
  "729": "Extraction d'autres minerais de métaux non ferreux",
  "73": "Publicité et études de marché",
  "731": "Publicité",
  "7311": "Activités des agences de publicité",
  "7311Z": "Activités des agences de publicité",
  "7312": "Régie publicitaire de médias",
  "7312Z": "Régie publicitaire de médias",
  "732": "Études de marché et sondages",
  "7320": "Études de marché et sondages",
  "7320Z": "Études de marché et sondages",
  "74": "Autres activités spécialisées, scientifiques et techniques",
  "741": "Activités spécialisées de design",
  "7410": "Activités spécialisées de design",
  "7410Z": "Activités spécialisées de design",
  "742": "Activités photographiques",
  "7420": "Activités photographiques",
  "7420Z": "Activités photographiques",
  "743": "Traduction et interprétation",
  "7430": "Traduction et interprétation",
  "7430Z": "Traduction et interprétation",
  "749": "Autres activités spécialisées, scientifiques et techniques n.c.a.",
  "7490": "Autres activités spécialisées, scientifiques et techniques n.c.a.",
  "7490A": "Activité des économistes de la construction",
  "7490B": "Activités spécialisées, scientifiques et techniques diverses",
  "75": "Activités vétérinaires",
  "750": "Activités vétérinaires",
  "7500": "Activités vétérinaires",
  "7500Z": "Activités vétérinaires",
  "77": "Activités de location et location-bail",
  "771": "Location et location-bail de véhicules automobiles",
  "7711":
    "Location et location-bail de voitures et de véhicules automobiles légers",
  "7711A":
    "Location de courte durée de voitures et de véhicules automobiles légers",
  "7711B":
    "Location de longue durée de voitures et de véhicules automobiles légers",
  "7712": "Location et location-bail de camions",
  "7712Z": "Location et location-bail de camions",
  "772": "Location et location-bail de biens personnels et domestiques",
  "7721": "Location et location-bail d'articles de loisirs et de sport",
  "7721Z": "Location et location-bail d'articles de loisirs et de sport",
  "7722": "Location de vidéocassettes et disques vidéo",
  "7722Z": "Location de vidéocassettes et disques vidéo",
  "7729": "Location et location-bail d'autres biens personnels et domestiques",
  "7729Z": "Location et location-bail d'autres biens personnels et domestiques",
  "773": "Location et location-bail d'autres machines, équipements et biens",
  "7731": "Location et location-bail de machines et équipements agricoles",
  "7731Z": "Location et location-bail de machines et équipements agricoles",
  "7732":
    "Location et location-bail de machines et équipements pour la construction",
  "7732Z":
    "Location et location-bail de machines et équipements pour la construction",
  "7733":
    "Location et location-bail de machines de bureau et de matériel informatique",
  "7733Z":
    "Location et location-bail de machines de bureau et de matériel informatique",
  "7734": "Location et location-bail de matériels de transport par eau",
  "7734Z": "Location et location-bail de matériels de transport par eau",
  "7735": "Location et location-bail de matériels de transport aérien",
  "7735Z": "Location et location-bail de matériels de transport aérien",
  "7739":
    "Location et location-bail d'autres machines, équipements et biens matériels n.c.a.",
  "7739Z":
    "Location et location-bail d'autres machines, équipements et biens matériels n.c.a.",
  "774":
    "Location-bail de propriété intellectuelle et de produits similaires, à l'exception des œuvres soumises à copyright",
  "7740":
    "Location-bail de propriété intellectuelle et de produits similaires, à l'exception des œuvres soumises à copyright",
  "7740Z":
    "Location-bail de propriété intellectuelle et de produits similaires, à l'exception des œuvres soumises à copyright",
  "78": "Activités liées à l'emploi",
  "781": "Activités des agences de placement de main-d'œuvre",
  "7810": "Activités des agences de placement de main-d'œuvre",
  "7810Z": "Activités des agences de placement de main-d'œuvre",
  "782": "Activités des agences de travail temporaire",
  "7820": "Activités des agences de travail temporaire",
  "7820Z": "Activités des agences de travail temporaire",
  "783": "Autre mise à disposition de ressources humaines",
  "7830": "Autre mise à disposition de ressources humaines",
  "7830Z": "Autre mise à disposition de ressources humaines",
  "79": "Activités des agences de voyage, voyagistes, services de réservation et activités connexes",
  "791": "Activités des agences de voyage et voyagistes",
  "7911": "Activités des agences de voyage",
  "7911Z": "Activités des agences de voyage",
  "7912": "Activités des voyagistes",
  "7912Z": "Activités des voyagistes",
  "799": "Autres services de réservation et activités connexes",
  "7990": "Autres services de réservation et activités connexes",
  "7990Z": "Autres services de réservation et activités connexes",
  "80": "Enquêtes et sécurité",
  "801": "Activités de sécurité privée",
  "8010": "Activités de sécurité privée",
  "8010Z": "Activités de sécurité privée",
  "802": "Activités liées aux systèmes de sécurité",
  "8020": "Activités liées aux systèmes de sécurité",
  "8020Z": "Activités liées aux systèmes de sécurité",
  "803": "Activités d'enquête",
  "8030": "Activités d'enquête",
  "8030Z": "Activités d'enquête",
  "81": "Services relatifs aux bâtiments et aménagement paysager",
  "811": "Activités combinées de soutien lié aux bâtiments",
  "8110": "Activités combinées de soutien lié aux bâtiments",
  "8110Z": "Activités combinées de soutien lié aux bâtiments",
  "812":
    "Exploitation de gravières et sablières, extraction d’argiles et de kaolin",
  "8121": "Nettoyage courant des bâtiments",
  "8121Z": "Nettoyage courant des bâtiments",
  "8122": "Autres activités de nettoyage des bâtiments et nettoyage industriel",
  "8122Z":
    "Autres activités de nettoyage des bâtiments et nettoyage industriel",
  "8129": "Autres activités de nettoyage",
  "8129A": "Désinfection, désinsectisation, dératisation",
  "8129B": "Autres activités de nettoyage n.c.a.",
  "813": "Services d'aménagement paysager",
  "8130": "Services d'aménagement paysager",
  "8130Z": "Services d'aménagement paysager",
  "82": "Activités administratives et autres activités de soutien aux entreprises",
  "821": "Activités administratives",
  "8211": "Services administratifs combinés de bureau",
  "8211Z": "Services administratifs combinés de bureau",
  "8219":
    "Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau",
  "8219Z":
    "Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau",
  "822": "Activités de centres d'appels",
  "8220": "Activités de centres d'appels",
  "8220Z": "Activités de centres d'appels",
  "823": "Organisation de salons professionnels et congrès",
  "8230": "Organisation de salons professionnels et congrès",
  "8230Z": "Organisation de foires, salons professionnels et congrès",
  "829": "Activités de soutien aux entreprises n.c.a.",
  "8291":
    "Activités des agences de recouvrement de factures et des sociétés d'information financière sur la clientèle",
  "8291Z":
    "Activités des agences de recouvrement de factures et des sociétés d'information financière sur la clientèle",
  "8292": "Activités de conditionnement",
  "8292Z": "Activités de conditionnement",
  "8299": "Autres activités de soutien aux entreprises n.c.a.",
  "8299Z": "Autres activités de soutien aux entreprises n.c.a.",
  "84": "Administration publique et défense ; sécurité sociale obligatoire",
  "841": "Administration générale, économique et sociale",
  "8411": "Administration publique générale",
  "8411Z": "Administration publique générale",
  "8412":
    "Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale",
  "8412Z":
    "Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale",
  "8413": "Administration publique (tutelle) des activités économiques",
  "8413Z": "Administration publique (tutelle) des activités économiques",
  "842": "Services de prérogative publique",
  "8421": "Affaires étrangères",
  "8421Z": "Affaires étrangères",
  "8422": "Défense",
  "8422Z": "Défense",
  "8423": "Justice",
  "8423Z": "Justice",
  "8424": "Activités d’ordre public et de sécurité",
  "8424Z": "Activités d’ordre public et de sécurité",
  "8425": "Services du feu et de secours",
  "8425Z": "Services du feu et de secours",
  "843": "Sécurité sociale obligatoire",
  "8430": "Sécurité sociale obligatoire",
  "8430A": "Activités générales de sécurité sociale",
  "8430B": "Gestion des retraites complémentaires",
  "8430C": "Distribution sociale de revenus",
  "85": "Enseignement",
  "851": "Enseignement pré-primaire",
  "8510": "Enseignement pré-primaire",
  "8510Z": "Enseignement pré-primaire",
  "852": "Enseignement primaire",
  "8520": "Enseignement primaire",
  "8520Z": "Enseignement primaire",
  "853": "Enseignement secondaire",
  "8531": "Enseignement secondaire général",
  "8531Z": "Enseignement secondaire général",
  "8532": "Enseignement secondaire technique ou professionnel",
  "8532Z": "Enseignement secondaire technique ou professionnel",
  "854": "Enseignement supérieur et post-secondaire non supérieur",
  "8541": "Enseignement post-secondaire non supérieur",
  "8541Z": "Enseignement post-secondaire non supérieur",
  "8542": "Enseignement supérieur",
  "8542Z": "Enseignement supérieur",
  "855": "Autres activités d'enseignement",
  "8551": "Enseignement de disciplines sportives et d'activités de loisirs",
  "8551Z": "Enseignement de disciplines sportives et d'activités de loisirs",
  "8552": "Enseignement culturel",
  "8552Z": "Enseignement culturel",
  "8553": "Enseignement de la conduite",
  "8553Z": "Enseignement de la conduite",
  "8559": "Enseignements divers",
  "8559A": "Formation continue d'adultes",
  "8559B": "Autres enseignements",
  "856": "Activités de soutien à l'enseignement",
  "8560": "Activités de soutien à l'enseignement",
  "8560Z": "Activités de soutien à l'enseignement",
  "86": "Activités pour la santé humaine",
  "861": "Activités hospitalières",
  "8610": "Activités hospitalières",
  "8610Z": "Activités hospitalières",
  "862": "Activité des médecins et des dentistes",
  "8621": "Activité des médecins généralistes",
  "8621Z": "Activité des médecins généralistes",
  "8622": "Activité des médecins spécialistes",
  "8622A": "Activités de radiodiagnostic et de radiothérapie",
  "8622B": "Activités chirurgicales",
  "8622C": "Autres activités des médecins spécialistes",
  "8623": "Pratique dentaire",
  "8623Z": "Pratique dentaire",
  "869": "Autres activités pour la santé humaine",
  "8690": "Autres activités pour la santé humaine",
  "8690A": "Ambulances",
  "8690B": "Laboratoires d'analyses médicales",
  "8690C": "Centres de collecte et banques d'organes",
  "8690D": "Activités des infirmiers et des sages-femmes",
  "8690E":
    "Activités des professionnels de la rééducation, de l’appareillage et des pédicures-podologues",
  "8690F": "Activités de santé humaine non classées ailleurs",
  "87": "Hébergement médico-social et social",
  "871": "Hébergement médicalisé",
  "8710": "Hébergement médicalisé",
  "8710A": "Hébergement médicalisé pour personnes âgées",
  "8710B": "Hébergement médicalisé pour enfants handicapés",
  "8710C":
    "Hébergement médicalisé pour adultes handicapés et autre hébergement médicalisé",
  "872":
    "Hébergement social pour personnes handicapées mentales, malades mentales et toxicomanes",
  "8720":
    "Hébergement social pour personnes handicapées mentales, malades mentales et toxicomanes",
  "8720A": "Hébergement social pour handicapés mentaux et malades mentaux",
  "8720B": "Hébergement social pour toxicomanes",
  "873": "Hébergement social pour personnes âgées ou handicapées physiques",
  "8730": "Hébergement social pour personnes âgées ou handicapées physiques",
  "8730A": "Hébergement social pour personnes âgées",
  "8730B": "Hébergement social pour handicapés  physiques",
  "879": "Autres activités d’hébergement social",
  "8790": "Autres activités d’hébergement social",
  "8790A": "Hébergement social pour enfants en difficultés",
  "8790B":
    "Hébergement social pour adultes et familles en difficultés et autre hébergement social",
  "88": "Action sociale sans hébergement",
  "881":
    "Action sociale sans hébergement pour personnes âgées et pour personnes handicapées",
  "8810":
    "Action sociale sans hébergement pour personnes âgées et pour personnes handicapées",
  "8810A": "Aide à domicile",
  "8810B":
    "Accueil ou accompagnement sans hébergement d’adultes handicapés ou de  personnes âgées",
  "8810C": "Aide par le travail",
  "889": "Autre action sociale sans hébergement",
  "8891": "Action sociale sans hébergement pour jeunes enfants",
  "8891A": "Accueil de jeunes enfants",
  "8891B": "Accueil ou accompagnement sans hébergement d’enfants handicapés",
  "8899": "Autre action sociale sans hébergement n.c.a.",
  "8899A":
    "Autre accueil ou accompagnement sans hébergement d’enfants\n et d’adolescents",
  "8899B": "Action sociale sans hébergement n.c.a.",
  "89": "Activités extractives n.c.a.",
  "891": "Extraction des minéraux chimiques et d'engrais minéraux",
  "892": "Extraction de tourbe",
  "893": "Production de sel",
  "899": "Autres activités extractives n.c.a.",
  "90": "Activités créatives, artistiques et de spectacle",
  "900": "Activités créatives, artistiques et de spectacle",
  "9001": "Arts du spectacle vivant",
  "9001Z": "Arts du spectacle vivant",
  "9002": "Activités de soutien au spectacle vivant",
  "9002Z": "Activités de soutien au spectacle vivant",
  "9003": "Création artistique",
  "9003A": "Création artistique relevant des arts plastiques",
  "9003B": "Autre création artistique",
  "9004": "Gestion de salles de spectacles",
  "9004Z": "Gestion de salles de spectacles",
  "91": "Activités de soutien à l'extraction d'hydrocarbures",
  "910": "Bibliothèques, archives, musées et autres activités culturelles",
  "9101": "Gestion des bibliothèques et des archives",
  "9101Z": "Gestion des bibliothèques et des archives",
  "9102": "Gestion des musées",
  "9102Z": "Gestion des musées",
  "9103":
    "Gestion des sites et monuments historiques et des attractions touristiques similaires",
  "9103Z":
    "Gestion des sites et monuments historiques et des attractions touristiques similaires",
  "9104":
    "Gestion des jardins botaniques et zoologiques et des réserves naturelles",
  "9104Z":
    "Gestion des jardins botaniques et zoologiques et des réserves naturelles",
  "92": "Organisation de jeux de hasard et d'argent",
  "920": "Organisation de jeux de hasard et d'argent",
  "9200": "Organisation de jeux de hasard et d'argent",
  "9200Z": "Organisation de jeux de hasard et d'argent",
  "93": "Activités sportives, récréatives et de loisirs",
  "931": "Activités liées au sport",
  "9311": "Gestion d'installations sportives",
  "9311Z": "Gestion d'installations sportives",
  "9312": "Activités de clubs de sports",
  "9312Z": "Activités de clubs de sports",
  "9313": "Activités des centres de culture physique",
  "9313Z": "Activités des centres de culture physique",
  "9319": "Autres activités liées au sport",
  "9319Z": "Autres activités liées au sport",
  "932": "Activités récréatives et de loisirs",
  "9321": "Activités des parcs d'attractions et parcs à thèmes",
  "9321Z": "Activités des parcs d'attractions et parcs à thèmes",
  "9329": "Autres activités récréatives et de loisirs",
  "9329Z": "Autres activités récréatives et de loisirs",
  "94": "Activités des organisations associatives",
  "941":
    "Activités des organisations économiques, patronales et professionnelles",
  "9411": "Activités des organisations patronales et consulaires",
  "9411Z": "Activités des organisations patronales et consulaires",
  "9412": "Activités des organisations professionnelles",
  "9412Z": "Activités des organisations professionnelles",
  "942": "Activités des syndicats de salariés",
  "9420": "Activités des syndicats de salariés",
  "9420Z": "Activités des syndicats de salariés",
  "949": "Activités des autres organisations associatives",
  "9491": "Activités des organisations religieuses",
  "9491Z": "Activités des organisations religieuses",
  "9492": "Activités des organisations politiques",
  "9492Z": "Activités des organisations politiques",
  "9499": "Activités des organisations associatives n.c.a.",
  "9499Z": "Autres organisations fonctionnant par adhésion volontaire",
  "95": "Réparation d'ordinateurs et de biens personnels et domestiques",
  "951": "Réparation d'ordinateurs et d'équipements de communication",
  "9511": "Réparation d'ordinateurs et d'équipements périphériques",
  "9511Z": "Réparation d'ordinateurs et d'équipements périphériques",
  "9512": "Réparation d'équipements de communication",
  "9512Z": "Réparation d'équipements de communication",
  "952": "Réparation de biens personnels et domestiques",
  "9521": "Réparation de produits électroniques grand public",
  "9521Z": "Réparation de produits électroniques grand public",
  "9522":
    "Réparation d'appareils électroménagers et d'équipements pour la maison et le jardin",
  "9522Z":
    "Réparation d'appareils électroménagers et d'équipements pour la maison et le jardin",
  "9523": "Réparation de chaussures et d'articles en cuir",
  "9523Z": "Réparation de chaussures et d'articles en cuir",
  "9524": "Réparation de meubles et d'équipements du foyer",
  "9524Z": "Réparation de meubles et d'équipements du foyer",
  "9525": "Réparation d'articles d'horlogerie et de bijouterie",
  "9525Z": "Réparation d'articles d'horlogerie et de bijouterie",
  "9529": "Réparation d'autres biens personnels et domestiques",
  "9529Z": "Réparation d'autres biens personnels et domestiques",
  "96": "Autres services personnels",
  "960": "Autres services personnels",
  "9601": "Blanchisserie-teinturerie",
  "9601A": "Blanchisserie-teinturerie de gros",
  "9601B": "Blanchisserie-teinturerie de détail",
  "9602": "Coiffure et soins de beauté",
  "9602A": "Coiffure",
  "9602B": "Soins de beauté",
  "9603": "Services funéraires",
  "9603Z": "Services funéraires",
  "9604": "Entretien corporel",
  "9604Z": "Entretien corporel",
  "9609": "Autres services personnels n.c.a.",
  "9609Z": "Autres services personnels n.c.a.",
  "97": "Activités des ménages en tant qu'employeurs de personnel domestique",
  "970": "Activités des ménages en tant qu'employeurs de personnel domestique",
  "9700": "Activités des ménages en tant qu'employeurs de personnel domestique",
  "9700Z":
    "Activités des ménages en tant qu'employeurs de personnel domestique",
  "98": "Activités indifférenciées des ménages en tant que producteurs de biens et services pour usage propre",
  "981":
    "Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre",
  "9810":
    "Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre",
  "9810Z":
    "Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre",
  "982":
    "Activités indifférenciées des ménages en tant que producteurs de services pour usage propre",
  "9820":
    "Activités indifférenciées des ménages en tant que producteurs de services pour usage propre",
  "9820Z":
    "Activités indifférenciées des ménages en tant que producteurs de services pour usage propre",
  "99": "Activités de soutien aux autres industries extractives",
  "990": "Activités des organisations et organismes extraterritoriaux",
  "9900": "Activités des organisations et organismes extraterritoriaux",
  "9900Z": "Activités des organisations et organismes extraterritoriaux"
};
